import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { Subject, forkJoin } from 'rxjs';
import { takeUntil, map } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { SessionStorageService } from '../../../services/session-storage.service';
import { PostTradeService } from '../../post-trade.service';
import { ptUtilityApps } from '../../../lib/utility-apps';
import { UtilityAppsService } from '../../../shared-components/utility-apps/utility-apps.service';

import { RbGridComponent } from '../../../shared-components/rb-grid/rb-grid.component';
import { RepReviewDetailComponent } from '../rep-review-detail/rep-review-detail.component';
import { BreadcrumbComponent } from '../../../breadcrumb/breadcrumb.component';
@Component({
  selector: 'app-rep-review',
  templateUrl: './rep-review.component.html',
  styleUrls: ['./rep-review.component.scss'],
  imports: [RbGridComponent, RepReviewDetailComponent, BreadcrumbComponent],
})
export class RepReviewComponent implements OnInit, OnDestroy {
  ptSvc = inject(PostTradeService);
  private activatedRoute = inject(ActivatedRoute);
  private ss = inject(SessionStorageService);
  private route = inject(Router);
  private uas = inject(UtilityAppsService);

  rights = [];
  unsubscribe: Subject<any> = new Subject();
  repId = '';
  gridConfig = {
    title: 'Financial Professional Monitor',
    gridName: 'RepReviewGrid',
    showGridFilters: true,
    showFilterManager: true,
    manualSearch: true,
    searchButtonText: 'Update Search',
    showBulkActions: true,
    downloadGridButton: true,
    gridActionColumn: true,
    selectActionText: 'Select FP',
    previewActionText: 'View FP',
    showActionId: true,
    rowSelector: 'RepID_Rev',
    gridType: 'rep',
    detailViewRoute: '/rep-review/',
    showGridColumnFilters: true,
    getSetup: this.getGridSetup,
    getData: this.getGridData,
    storeGridNav: true,
    defaultPageSize: 100,
  };
  crumbConfig = [
    {
      label: 'Post Transaction',
      link: 'post-trade/RR',
    },
    {
      label: 'Financial Professional Monitor',
      link: 'rep-review',
    },
  ];

  ngOnInit(): void {
    this.uas.appsList.set(ptUtilityApps);
    this.rights = this.ss.get('rights');
    this.activatedRoute.params
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(params => {
        if (params.id) {
          this.repId = params.id;
          this.crumbConfig.push({
            label: 'Financial Professional Detail',
            link: `trade-review/${this.repId}`,
          });
        } else {
          this.repId = '';
        }
      });

    if (this.rights.includes('PostTradeReadOnly')) {
      this.gridConfig.showBulkActions = false;
    }
  }

  ngOnDestroy() {
    this.uas.appsList.set([]);
    this.unsubscribe.next(null);
    this.unsubscribe.complete();
  }

  nav(location) {
    this.route.navigate([`/${location}`]);
  }

  getGridSetup() {
    const ssFilters = this.ss.get('RepReviewGridFilters');
    const defaultview = {
      filter: [],
      sort: [],
    };

    if (!ssFilters) {
      defaultview.filter.push({
        ProcessedDate: {
          selected: ['30 days'],
        },
      });
    }

    const getHeaders = this.ptSvc.getRepGridSetup();

    return forkJoin([getHeaders]).pipe(
      map(([data1]) => ({ ...data1, defaultview }))
    );
  }

  getGridData(reqData) {
    return this.ptSvc.getRepGridData(reqData);
  }
}
